var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card hera-card-panel",class:[
    ("hera-card-panel--" + _vm.variant),
    {
      'load-data': _vm.isLoadData,
      'is-loading': _vm.isLoading,
      'is-loading-error': _vm.isLoadingError,
    } ]},[_c('div',{staticClass:"card-body m-0 p-0"},[_vm._t("default")],2),(_vm.isLoading && _vm.isLoading)?_c('Loader'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }